import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = {
    deleteUrl: String,
    editUrl: String,
    makeActiveUrl: String,
    projectUrl: String,
    isCreator: { type: Boolean, default: false }
  }

  connect() {
    this.element.addEventListener("contextmenu", this.open.bind(this))
    this._closeHandler = this.close.bind(this)
    document.addEventListener("click", this._closeHandler)
    document.addEventListener("contextmenu", this._closeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._closeHandler)
    document.removeEventListener("contextmenu", this._closeHandler)
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    // Close any other open context menus first
    document.querySelectorAll(".context-menu[style*='display: block']").forEach(el => {
      el.style.display = "none"
    })

    const menu = this.menuTarget
    menu.style.display = "block"
    menu.style.position = "fixed"
    menu.style.left = `${event.clientX}px`
    menu.style.top = `${event.clientY}px`
    menu.style.zIndex = "1000"
  }

  close(event) {
    if (!this.menuTarget.contains(event.target)) {
      this.menuTarget.style.display = "none"
    }
  }

  edit(event) {
    event.preventDefault()
    this.menuTarget.style.display = "none"

    // Trigger turbo frame modal by visiting the edit URL
    const frame = document.querySelector("turbo-frame#modal-container")
    if (frame) {
      frame.src = this.editUrlValue
    }
  }

  destroy(event) {
    event.preventDefault()
    this.menuTarget.style.display = "none"

    // Use Rails UJS / Turbo to send a DELETE request (triggers the confirmation modal)
    const link = document.createElement("a")
    link.href = this.deleteUrlValue
    link.dataset.method = "delete"
    link.dataset.turbo = "true"
    link.style.display = "none"
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  select(event) {
    // Don't navigate if the context menu is open or if the click was on a context menu item
    if (this.menuTarget.style.display === "block") return
    if (event.target.closest(".context-menu")) return

    event.preventDefault()

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    fetch(this.makeActiveUrlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => response.text())
      .then(html => {
        // Let Turbo process the stream to update the sidebar (which is data-turbo-permanent)
        Turbo.renderStreamMessage(html)
        Turbo.visit(this.projectUrlValue)
      })
  }
}
